import type { LinkProps } from '@joinrepublic/dls-ui-kit';

/**
 * Shared styles for the header links, expressed in DLS tokens so they resolve under both the pure
 * DLS `theme` and `republicLegacy`.
 *
 * They replace the legacy-only `variant="republic-default"`, which does not exist in the DLS theme:
 * without it the links fall back to the `Link` baseStyle and render underlined and in `grey.600`.
 * `noDecoration` is the DLS equivalent for the underline; the rest of what the legacy variant
 * provided (inherited colour, pointer cursor, focus ring) is restored here explicitly.
 *
 * TODO: migrate the remaining `republic-*` variants across the app and drop the `size` below —
 * https://linear.app/republic/issue/CLG-214/close-the-legacy-only-theme-gaps-that-break-shared-components-under
 */
export const headerLinkStyles: LinkProps = {
  variant: 'noDecoration',
  // Chakra applies `defaultProps.size` only when `size` is undefined, so passing a value the theme
  // ignores suppresses the DLS default of `body-md` (fontSize `md` / lineHeight `1.5rem`), which
  // these links never had. `sizes['republic-default']: {}` in the legacy theme is the escape hatch
  // for exactly this; the DLS theme has no such key, which resolves identically.
  size: 'republic-default',
  color: 'inherit',
  cursor: 'pointer',
  _focusVisible: { boxShadow: 'outline' },
};
